import React, { Component } from "react";
import { BreadCumb, NewDocTable, NavBar, TimeOut } from "../../components";
import config from "../../config";
import moment from "moment";
import { ApiClient } from "../../libs/apiClient";
import { DISPATCH_ID, SERVICE_RESPONSE } from "../../libs/utils/Const";
import { connect } from "react-redux";
const apiClient = ApiClient.getInstance();
const today = moment(new Date()).format("YYYYMMDD");

const headers = [
    { title: "No. Producto", value: true },
    { title: "Descripción", value: true },
    { title: "Tipo LMat", value: true },
    { title: "Cantidad", value: true },
    { title: "Almacen", value: true },
    { title: "Lista de Precios", value: true },
    { title: "Norm. Reparto", value: true },
    { title: "Precio de producto", value: true },
];

class ProductTree extends Component {
    constructor(props) {
        super(props);
        this.state = {
            updateData: false,
            data: [],
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + "currentUser")),
            projects: [],
        };
    }

    async componentDidMount() {
        const date = {
            dateInit: today,
            dateFinal: today,
        };

        await this.searchDocuments(date);
        let avalibleProjects = await apiClient.getProjectsList({ type: 'A' });
        this.setState({
            projects: avalibleProjects.data || [],
        })
    }



    searchDocuments = async (newDate) => {
        const { enableSpinner } = this.props;

        const data = {
            dateInit: newDate.dateInit,
            dateFinal: newDate.dateFinal,
            switch1: newDate.docStatus || "---",
            table: "OITT",
            docNumSearch: newDate.docNumSearch || "--",
        };

        enableSpinner(true);
        const response = await apiClient.getDocumentsList(data);
        enableSpinner(false);

        if (response.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({ data: response.data });
        }
    }

    render() {
        const { data, _user, projects } = this.state;
        return (
            <div className="content">
                <NavBar props={this.props} _user={_user} />
                <BreadCumb subitem1={"LISTA DE MATERIALES"} url1={"#"} />
                <TimeOut />
                <div style={{ marginLeft: "4rem", marginBottom: "12rem" }}>
                    <h2 className="md-display-1">
                        <a id="linkOrdProv" className="text-muted">
                            &nbsp;LISTA DE MATERIALES
                        </a>
                    </h2>
                    <NewDocTable
                        headers={headers}
                        view={"productTree"}
                        data={data}
                        search={this.searchDocuments}
                        projects={projects}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (store) => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = (dispatch) => {
    return {
        enableSpinner: (value) => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value }),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProductTree);